<template>
  <div id="NavBar">
    <!-- Navigation Bar -->
    <b-navbar type="is-black" :spaced="true" :fixed-top="true">
      <template slot="brand">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">
          <h1>SECRET STOREY</h1>
        </b-navbar-item>
      </template>
      <template slot="end">
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'home' }"
          :class="{ 'is-active': this.$route.name === 'home' }"
          >Home</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'menu' }"
          :class="{ 'is-active': this.$route.name === 'menu' }"
          >Our Menu</b-navbar-item
        >
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'rental' }"
          :class="{ 'is-active': this.$route.name === 'rental' }"
          >Rental Space</b-navbar-item
        >
      </template>
    </b-navbar>
    <router-view />
    <!-- Footer -->
    <secret-fotter />
  </div>
</template>

<script>
import SecretFotter from "@/components/SecretFotter";

export default {
  name: "NavBar",
  components: {
    SecretFotter
  }
};
</script>

<style></style>
